import React, { useState } from 'react'

import { Link } from 'react-router-dom'
import Table, { ColumnDefinitionType } from '../../../../../components/Table'
import { Loading } from '../../../../../components/Loading'
import Confirm from '../../../../../components/Confirm'
import { perfilInitial } from '../../../../../context/Seguridad/PerfilReducer'
import { Perfil } from '../../../../../types/Perfil'
import { usePerfil } from '../../../../../hooks/usePerfil'


const TablePerfil = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [data, setData] = useState<Perfil>(perfilInitial);
    const toggle = () => setShowModal(!showModal);

    const eliminar = () => {
        eliminarPerfil(data.id as unknown as string);
        toggle();
    }

    const { eliminarPerfil, perfilList, loading } = usePerfil();
    const columns: ColumnDefinitionType<Perfil, keyof Perfil>[] = [
        {
            key: 'descripcion',
            header: 'Descripción',
        },

        {
            key: 'estado',
            header: 'Estado',
            cell: (data: Perfil) => <>{data.estado ? 'Activo' : 'Inactivo'}</>
        },

        {
            key: 'id',
            header: 'Acciones',
            cell: (data: Perfil) =>
                <>
                    <Link to={`/perfiles/editar/${data.id}`} title="Editar" >
                        <i className="fa fa-pencil text-custom" aria-hidden="true"></i>
                    </Link>
                    <Link to="#" title="eliminar"
                        onClick={(e) => {
                            e.stopPropagation();
                            setData(data);
                            setShowModal(true)

                        }}
                    >
                        <i className="fa fa-trash-o mr-2 text-danger" aria-hidden="true"></i>
                    </Link>
                </>
        },
    ]


    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        {<p>Está seguro que desea eliminar el Perfil {data.descripcion}?</p>}
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h4 className="m-t-0 header-title">
                                        <i className="fa fa-list-ul" aria-hidden="true" style={{ marginRight: "5px" }}></i>

                                        Lista

                                        <Link to={`/perfiles/nuevo`} title="Nuevo" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}>
                                            <i className="fa fa-plus margin-right-10"></i> Nuevo
                                        </Link>
                                    </h4>

                                </div>

                                <div className="table-responsive">
                                    <br />
                                    {loading ? <Loading /> : <Table data={perfilList || []} columns={columns}></Table>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    )
}

export default TablePerfil;